import React from "react";
import { motion } from "framer-motion";
import { HiArrowUpRight } from "react-icons/hi2";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const ProjectCell = ({ title, description, url, icon, className = "" }) => {
  return (
    <motion.a
      variants={item}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`bento-cell p-5 lgl:p-6 flex flex-col justify-between gap-3 group cursor-pointer ${className}`}
    >
      <div className="flex items-start justify-between">
        <div className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-designColor text-lg
                        group-hover:bg-designColor/10 group-hover:border-designColor/20 transition-all duration-300">
          {icon}
        </div>
        <HiArrowUpRight className="text-gray-600 group-hover:text-designColor group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
      </div>

      <div>
        <h3 className="text-lg font-bold text-white font-titleFont mb-1">
          {title}
        </h3>
        <p className="text-xs text-gray-500 leading-relaxed line-clamp-3">
          {description}
        </p>
      </div>
    </motion.a>
  );
};

export default ProjectCell;
